import GladeRedirectProvider from './GladeRedirectProvider';

export default GladeRedirectProvider;
